<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

    page: {
        title: 'Новая интеграция',
        meta: [{ name: 'description', content: appConfig.description }],
    },

    components: { Layout, PageHeader, Multiselect },

    data() {
        return {
            title: 'Новая интеграция',
            items: [],
            integration_uuid: '',
            name: '',
            trackBy: 'id',
            initStatus: [],
            status: null,
            status_options: [
                {id: 'enabled', name: 'Включена'},
                {id: 'disabled', name: 'Выключена'}
            ]
        }
    },

    watch: {
        initStatus: {
            immediate: true,
            handler(values) {
                this.status = this.status_options.filter(x => values.includes(x[this.trackBy]));
                this.status = this.status[0];
            }
        },
    },

    computed: {
        integration_item(){
            return this.$store.getters['integrations/GET_INTEGRATIONS_ITEM'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
    },

    async mounted() {
        this.integration_uuid = this.$route.params.integration_uuid ? this.$route.params.integration_uuid : '';
        if(this.integration_uuid !== ''){

            this.title = 'Редактирование интеграции';
            document.title = appConfig.title + ' - ' + 'Редактирование интеграции';

            let data_send = {
                'uuid' : this.integration_uuid
            }

            await this.$store.dispatch('integrations/FETCH_INTEGRATIONS_ITEM', data_send);

            this.name   = this.integration_item.name ? this.integration_item.name : '';
            this.status = this.integration_item.status ? this.integration_item.status : '';
            this.initStatus = [this.status];

        }
    },

    methods: {

        async saveItem(){

            let data_send = {
                'name'   : this.name,
                'status' : this.status && this.status.id ? this.status.id : null,
            };

            let result = '';

            if(this.integration_uuid === ''){
                result = await this.$store.dispatch('integrations/FETCH_INTEGRATIONS_CREATE', data_send);
            } else {
                data_send.uuid = this.integration_uuid;
                result = await this.$store.dispatch('integrations/FETCH_INTEGRATIONS_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Integrations'});
            }
        }
    },
}

</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <b-form-group
                                        label="Название интеграции"
                                        label-for="name"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="name"
                                            placeholder="Укажите название"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Статус"
                                        label-for="status"
                                    >
                                        <multiselect
                                            id="status"
                                            :track-by="trackBy"
                                            v-model="status"
                                            :options="status_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
    </Layout>
</template>
